export const hideAndShowMemberSubscription = (data, value) => {
  const updatedFormData = {
    ...data,
    formFields: data.formFields.map((field) => {
      if (field.id === "linkedMember") {
        const isEnable = value?.value === 2;

        return {
          ...field,
          fieldSetting: {
            ...field.fieldSetting,
            isDisable: !isEnable,
          },
          validation: isEnable ? [{ type: "require" }] : [],
        };
      }
      return field;
    }),
  };

  updatedFormData.initialState = {
    ...data.initialState,
    linkedMember: value?.value === 2 ? data.initialState.linkedMember : null,
  };

  return updatedFormData;
};


export const hideAndShowReinstatementFee = (data, value) => {
  const updatedFormData = {
    ...data, formFields: data.formFields.map((field) => {
      if (field.id === "reinstatementfee") {
        const enable = value === 3;

        return {
          ...field, fieldSetting: {
            ...field.fieldSetting,
            options: field.fieldSetting.options.map(opt => ({
              ...opt,
              isDisable: !enable
            }))
          },
          validation: enable ? [{ type: "require" }] : []
        };
      }
      return field;
    })
  };

  return updatedFormData;
};

export const getSubscriptionPrice = (pricing, applicationType, applicationTerm) => {
  if (!pricing) return null;

  switch (applicationType) {
    case 1:
      if (applicationTerm === 4) return pricing?.standardHalfYear;
      if (applicationTerm === 1) return pricing?.standard1Year;
      if (applicationTerm === 2) return pricing?.standard2Year;
      if (applicationTerm === 3) return pricing?.standard2YearLimitedTimeOnly;
      break;

    case 2:
      if (applicationTerm === 4) return pricing?.subsidiaryHalfYear;
      if (applicationTerm === 1) return pricing?.subsidiary1Year;
      if (applicationTerm === 2) return pricing?.subsidiary2Year;
      if (applicationTerm === 3) return pricing?.subsidary2YearLimitedTimeOnly;
      break;

    case 3:
      if (applicationTerm === 2) return pricing?.sgbcBundle2Year;
      break;
  }

  return null;
};

export const getOverseasSubscriptionPrice = (pricing, value) => {
  if (!pricing) return null;

  if (value === "yes") {
    return pricing?.overseasCharges;
  }
  return null;
};

export const getReinstatementSubscriptionPrice = (pricing, value) => {
  if (!pricing) return null;

  if (value === "yes") {
    return pricing?.reinstatementFee;
  }
  return null;
};

export const filterApplicationTerms = (terms, applicationType) => {
  if (!applicationType) return terms;
  switch (applicationType) {
    case "Standard":
      return terms.filter(t =>
        t.name === "1 Year" ||
        t.name === "2 Year" ||
        t.name === "2 Year Limited Time Only" ||
        t.name === "0.5 Year"
      );

    case "Subsiduary":
      return [];

    case "Bundle":
      return terms.filter(t => t.name === "2 Year");

    default:
      return terms;
  }
};

// export const getSubsidiaryTerms = (companyAStart, companyAEnd, childEnd) => {
//   const today = new Date();
//   const start = new Date(companyAStart);
//   const end = new Date(companyAEnd);
//   const childEndDate = childEnd ? new Date(childEnd) : null;
//   const month = today.getMonth() + 1;
//   const year = today.getFullYear();

//   const startYear = start.getFullYear();
//   const endYear = end.getFullYear();
//   const childEndYear =  childEnd ? childEndDate.getFullYear(): null;

//    if (childEndYear > endYear) {
//     return null;
//   }

//   if (startYear === endYear) {
//     if (year === startYear) {
//       if (month >= 1 && month <= 6) {
//         return ["1 Year"];
//       } else if (month >= 7 && month <= 12) {
//         return ["0.5 Year"];
//       }
//     }
//     return [];
//   }

//   if (endYear > startYear) {
//     if (year === startYear) {
//       if (month >= 1 && month <= 6) {
//          return childEndYear < endYear ? ["1 Year", "2 Year"] : ["1 Year"];
//       } else if (month >= 7 && month <= 12) {
//         // return ["0.5 Year", "1 Year", "2 Year Limited Time Only"];
//        return childEndYear < endYear ? ["0.5 Year", "1 Year", "2 Year Limited Time Only"] : ["0.5 Year", "1 Year"];
//       }
//     }

//     if (year === endYear) {
//       if (month >= 1 && month <= 6) {
//         return ["1 Year"];
//       } else if (month >= 7 && month <= 12) {
//         return ["0.5 Year"];
//       }
//     }
//   }

//   if (month >= 1 && month <= 6) {
//          return childEndYear < endYear ? ["1 Year", "2 Year"] : ["1 Year"];
//       } else if (month >= 7 && month <= 12) {
//         // return ["0.5 Year", "1 Year", "2 Year Limited Time Only"];
//        return childEndYear < endYear ? ["0.5 Year", "1 Year", "2 Year Limited Time Only"] : ["0.5 Year", "1 Year"];
//       }
// };


export const getSubsidiaryTerms = (companyAStart, companyAEnd, childEnd) => {
  const today = new Date();
  const start = new Date(companyAStart);
  const end = new Date(companyAEnd);
  const childEndDate = childEnd ? new Date(childEnd) : null;

  const month = today.getMonth() + 1;
  const year = today.getFullYear();

  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  const childEndYear = childEndDate ? childEndDate.getFullYear() : null;

  // ? invalid case
  if (childEndYear > endYear) {
    return [];
  }

  // NEW PRIORITY RULE
  if (childEndYear !== null &&(childEndYear === year || childEndYear === year - 1) &&endYear === year + 1) {
    return ["1 Year", "0.5 Year"];
  }

  // Same start & end year
  if (startYear === endYear) {
    if (year === startYear) {
      if (month <= 6) return ["1 Year"];
      return ["0.5 Year"];
    }
    return [];
  }

  // Multi-year membership
  if (endYear > startYear) {
    if (year === startYear) {
      if (month <= 6) {
        return childEndYear < endYear ? ["1 Year", "2 Year"] : ["1 Year"];
      } else {
        return childEndYear < endYear
          ? ["0.5 Year", "1 Year", "2 Year Limited Time Only"]
          : ["0.5 Year", "1 Year"];
      }
    }

    if (year === endYear) {
      if (month <= 6) return ["1 Year"];
      return ["0.5 Year"];
    }
  }

  // ?? Final fallback (your new bottom block)
  if (month <= 6) {
    return childEndYear < endYear ? ["1 Year", "2 Year"] : ["1 Year"];
  } else {
    return childEndYear < endYear
      ? ["0.5 Year", "1 Year", "2 Year Limited Time Only"]
      : ["0.5 Year", "1 Year"];
  }
};


export const termValueMap = {
  "1 Year": 1,
  "2 Year": 2,
  "2 Year Limited Time Only": 3,
  "0.5 Year": 4,
  // "2 Year Limited Time Only": 5,
};
